import axiosInstance from "src/common/axiosInstance";

/**
 * WhatsApp message templates.
 *
 * Templates are read from Auto Appy's synchronized local copy; Meta stays the
 * source of truth and `sync` refreshes the copy.
 */
const templateService = {
  base(workspaceId, accountId) {
    return `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/templates`;
  },

  list(workspaceId, accountId, params = {}) {
    return axiosInstance.get(this.base(workspaceId, accountId), { params });
  },

  show(workspaceId, accountId, templateId) {
    return axiosInstance.get(
      `${this.base(workspaceId, accountId)}/${templateId}`,
    );
  },

  sync(workspaceId, accountId, { async = false } = {}) {
    return axiosInstance.post(
      `${this.base(workspaceId, accountId)}/sync`,
      {},
      { params: async ? { async: 1 } : {} },
    );
  },

  /**
   * Create a template and submit it to Meta for review. `payload` is the
   * structured template form (see TemplatePage).
   */
  create(workspaceId, accountId, payload) {
    return axiosInstance.post(this.base(workspaceId, accountId), payload);
  },

  /**
   * Upload a sample file for a media header. Returns { data: { handle } };
   * the handle goes into payload.header.media_handle.
   */
  uploadHeaderMedia(workspaceId, accountId, file) {
    const body = new FormData();
    body.append("file", file);
    return axiosInstance.post(
      `${this.base(workspaceId, accountId)}/media`,
      body,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
  },

  /**
   * Approved templates for the account that owns a phone number
   * (used by the conversation composer).
   */
  forPhoneNumber(phoneNumberId, params = {}) {
    return axiosInstance.get(`/phone-numbers/${phoneNumberId}/templates`, {
      params,
    });
  },

  /**
   * Set the account's WABA id. With no body Meta is asked to auto-detect it
   * (200 = detected/saved, 409 = several candidates in `data`, 422 = none).
   */
  setWaba(workspaceId, accountId, wabaId) {
    return axiosInstance.post(
      `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/waba`,
      wabaId ? { waba_id: wabaId } : {},
    );
  },
};

export default templateService;
